export const REDIRECT_URLS = {
  "beta" : "http://sso-beta.carmudi.com.ph/google?redirect=",
	"preprod" : "https://pre-sso.carmudi.com.ph/google?redirect=",
	"prod" : "https://sso.carmudi.com.ph/google?redirect=",
	"local" : "http://sso-beta.carmudi.com.ph/google?redirect="
}


export const API_URL = {
    GETWAY_API: process.env.REACT_APP_GETWAY_API+'megabox/',
    GETWAY_DOCS_API: process.env.REACT_APP_GETWAY_API+'megabox/' 
};

export const APIV = 1;

export const apikey = `insurancebox-ac1faa7b-9fe9-4483-9525-5cc4ce94c639`;

export const API_VERSION_V2 = 'v2';

export const REDIRECT_URL = REDIRECT_URLS[process.env.REACT_APP_ENV as keyof typeof REDIRECT_URLS || "local"];

export const KEY_ACTIVE_TAB_MAP: Record<string, string> = {
  first: 'all',
  second: 'due_in_14',
  third: 'overdue',
  fourth: 'about_to_expire',
  fifth: 'fully_paid'
};
export const DESCRIPTION_VALIDATION = {min: 3, max: 500}; 
export const ROLE_NAME_VALIDATION = {min: 3, max: 30 };


export const ROLE_FEATURES = {
  "Admin": 1,
  "Finance": 2,
  "Reconciliation": 3,
  "Collections":4,
  "Leads":5
}

export const DOC_UPLOAD_VALIDATION = {"minSize": 25000, "maxSize": 5000000}
export const AGENCY_STATUS = {
    "inactive":0,
    "active": 1, 
    "inprogress":2,
    "rejected": 3
}



export const CURRENCY_CODE = 'id-ID';
export const CURRENCY_SYMBOL = '₱';
export const APP_TYPE_AGENCY = 4;

export const USER_EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const USER_NAME_VALIDATION = {min: 3, max: 30 };
export const USERLIST_MOBILE_REGEX = /^[0-9]{9,12}$/;
export const USERLIST_PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

export const USER_MOBILE_REGEX = /^[9]\d{9}$/;
export const USER_PASSWORD_REGEX = /^(?=.*?[A-Z])(?=(.*[a-z]){1,})(?=(.*[\d]){1,})(?=(.*[\W]){1,})(?!.*\s).{8,}$/;
export const COUNTRY_CODE = process.env.REACT_APP_COUNTRY_CODE
export const ALLOW_ALPHABET = /^[A-Za-z\s]+$/
export const ALLOW_CHAR_NUM = /^[a-zA-Z0-9]+$/

export const KEY_RECONCILIATION_ACTIVE_TAB_MAP: Record<string, string> = {
  first: 'all',
  second: 'pending',
  third: 'verified',
  fourth: 'rejected'
};
export const KEY_PAYMENT_ACTIVE_TAB_MAP: Record<string, string> = {
  first: 'all',
  second: 'pending',
  third: 'verified',
  fourth: 'rejected'
};

export const MANAGER_LEVEL_IDS = [1,2,3]

export const RAGEX_NUMBER_UPTO_2_DECIMAL_PLACES = /^[0-9]*\.?[0-9]{0,2}$/

export const ROLES = { ADMIN: 1, SALES_HEAD:2, SALES_MANAGER:3, COLLECTIONS_SALES_AGENT:4, FINANCE_TEAM:5, RECO_TEAM: 6};
